import type { ReactNode } from "react";
import { LoadingState } from "./Spinner";

// PageLoading — the uniform full-page "initial fetch in progress" state.
// Replaces the pattern of rendering a <PageHead title="Loading…" />, which put
// a giant "Loading…" headline where the page title belongs and read as broken.
// Keeps the section eyebrow/sub for context and shows a real spinner instead.
export interface PageLoadingProps {
  /** Small section label above the spinner (e.g. "Operations · search status"). */
  eyebrow?: ReactNode;
  /** Sub-line under the spinner card (e.g. "Fetching health snapshot."). */
  sub?: ReactNode;
  /** Spinner label. Defaults to "Loading…". */
  label?: string;
}

export function PageLoading({
  eyebrow,
  sub,
  label = "Loading…",
}: PageLoadingProps): JSX.Element {
  return (
    <div className="page__loading" data-testid="page-loading">
      {eyebrow !== undefined && (
        <div className="page__head__eyebrow">{eyebrow}</div>
      )}
      <LoadingState label={label} />
      {sub !== undefined && <div className="page__head__sub">{sub}</div>}
    </div>
  );
}
